module.exports = __webpack_public_path__ + "img/greyRankIcon.7f11a30c.png";